/** Shared Chillverify AI defaults — Vercel AI Gateway is the primary provider. */

export const DEFAULT_AI_PROVIDER = 'vercel';

export const AI_PROVIDER_OPTIONS = [
  { value: 'vercel', label: 'Vercel AI Gateway (GPT-4o mini)' },
  { value: 'vercel-gpt4o', label: 'Vercel AI Gateway (GPT-4o)' },
  { value: 'vercel-claude', label: 'Vercel AI Gateway (Claude Sonnet)' },
  { value: 'together', label: 'Together AI (Llama 3.3 70B)' },
  { value: 'together-qwen', label: 'Together AI (Qwen 2.5 7B Turbo)' },
  { value: 'openai', label: 'OpenAI (GPT-4o)' },
  { value: 'openai-4o', label: 'OpenAI (GPT-4o)' },
  { value: 'anthropic', label: 'Anthropic (Claude Sonnet)' },
  { value: 'anthropic-opus', label: 'Anthropic (Claude Opus)' },
];

export const AI_NODE_TYPES = new Set([
  'function',
  'aiTransform',
  'bleDecoder',
  'bleAutoDetect',
  'bleElaPtEn',
  'bleKbPro',
  'bleSigmaWit',
]);

export function getDefaultTogetherApiKey() {
  return (
    (typeof process !== 'undefined' && process.env?.REACT_APP_TOGETHER_API_KEY?.trim()) ||
    ''
  );
}

export function getDefaultAiConfig() {
  return {
    aiProvider: DEFAULT_AI_PROVIDER,
    aiApiKey: getDefaultTogetherApiKey(),
  };
}

/** Vercel / Together can use the server-side key when the field is empty. */
export function hasConfiguredAi(config) {
  if (!config?.aiProvider) return false;
  const provider = config.aiProvider;
  if (provider.startsWith('vercel') || provider === 'ai-gateway' || provider.startsWith('together')) {
    return true;
  }
  return Boolean(config.aiApiKey?.trim());
}

export function aiApiKeyPlaceholder(provider) {
  if (!provider) return 'AI API key...';
  if (provider.startsWith('openai')) return 'sk-...';
  if (provider.startsWith('anthropic')) return 'sk-ant-...';
  if (provider.startsWith('vercel') || provider === 'ai-gateway') {
    return 'optional — uses server AI_GATEWAY_API_KEY if empty';
  }
  if (provider.startsWith('together')) return 'tg... (optional — uses server key if empty)';
  return 'AI API key...';
}
